const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const desmancheService = {
  // Crear nuevo registro de desmanche
  createDesmanche: async (data) => {
    try {
      const response = await fetch(`${API_URL}/desmanche/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Error al crear el registro de desmanche');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating desmanche:', error);
      throw error;
    }
  },

  // Obtener registros con filtros
  getDesmanche: async (filters = {}) => {
    try {
      const response = await fetch(`${API_URL}/desmanche/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filters),
      });

      if (!response.ok) {
        throw new Error('Error al obtener los registros de desmanche');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching desmanche:', error);
      throw error;
    }
  },

  // Obtener por ID
  getDesmancheById: async (id) => {
    try {
      const response = await fetch(`${API_URL}/desmanche/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Error al obtener el registro de desmanche');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching desmanche by ID:', error);
      throw error;
    }
  },

  // Actualizar registro
  updateDesmanche: async (id, data) => {
    try {
      const response = await fetch(`${API_URL}/desmanche/update/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Error al actualizar el registro de desmanche');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating desmanche:', error);
      throw error;
    }
  },

  // Finalizar proceso de desmanche
  finalizarDesmanche: async (id, data) => {
    try {
      const response = await fetch(`${API_URL}/desmanche/finalizar/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Error al finalizar el proceso de desmanche');
      }

      return await response.json();
    } catch (error) {
      console.error('Error finalizando desmanche:', error);
      throw error;
    }
  },

  // Eliminar registro
  deleteDesmanche: async (id) => {
    try {
      const response = await fetch(`${API_URL}/desmanche/delete/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Error al eliminar el registro de desmanche');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting desmanche:', error);
      throw error;
    }
  },

  // Obtener estadísticas
  getEstadisticas: async (edificioId) => {
    try {
      const params = edificioId ? `?edificioId=${edificioId}` : '';
      const response = await fetch(`${API_URL}/desmanche/estadisticas/general${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Error al obtener las estadísticas');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching estadisticas:', error);
      throw error;
    }
  },

  // Obtener indicadores con filtros
  getIndicadores: async (filters = {}) => {
    try {
      const response = await fetch(`${API_URL}/desmanche/indicadores`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filters),
      });

      if (!response.ok) {
        throw new Error('Error al obtener los indicadores');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching indicadores:', error);
      throw error;
    }
  },
};

export default desmancheService;
